import IconContainer, { IconContainerProps } from "./IconContainer";

export default function IconChart(props: IconContainerProps) {
    return <IconContainer {...props}>
        bar_chart_4_bars
    </IconContainer>
}
